import React, { useState } from "react";
import { Card, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";

function KnowledgeBase() {
  const navigate = useNavigate();

  // Filtre state
  const [filters, setFilters] = useState({
    reportType: "",
    company: "",
    keyword: "",
  });

  // Mock data (sonra backend'den gelecek)
  const [problems] = useState([
    {
      id: 1,
      reportType: "sikayet",
      company: "Müşteri A",
      title: "Galvanizli Çelik Üzerindeki Beyaz Pas",
      shortTitle: "Beyaz Pas",
      cause: "Üretim sırasında malzeme kalitesizliği ve hatalı soğutma yöntemleri.",
      description:
        "Üretim sürecinde malzeme kalitesinin düşük olması ve soğutma yöntemlerinin eksikliği yüzey pürüzlülüklerine yol açmaktadır.",
      lossKg: 120,
      returnStatus: "Yok",
    },
    {
      id: 2,
      reportType: "bilgi",
      company: "Müşteri B",
      title: "2x50x50 Profillerde Yüzey Pürüzlülüğü",
      shortTitle: "Pürüzlü Yüzey",
      cause: "Soğutma yöntemi eksikliği.",
      description:
        "Pürüzlü yüzeyler müşteri şikayetlerine ve ürün kalitesinde düşüşe neden olmaktadır.",
      lossKg: 60,
      returnStatus: "Var",
    },
    {
      id: 3,
      reportType: "kalite",
      company: "Müşteri A",
      title: "Boyada Çatlama Problemi",
      shortTitle: "Boya Çatlağı",
      cause: "Yetersiz kurutma süresi",
      description: "Kurutma hattında süre kısa olduğundan boya çatlakları oluştu.",
      lossKg: 30,
      returnStatus: "Yok",
    },
  ]);

  // Filtreleme mantığı
  const filteredProblems = problems.filter((p) => {
    const matchReport = filters.reportType ? p.reportType === filters.reportType : true;
    const matchCompany = filters.company ? p.company === filters.company : true;
    const matchKeyword = filters.keyword
      ? p.title.toLowerCase().includes(filters.keyword.toLowerCase()) ||
        p.shortTitle.toLowerCase().includes(filters.keyword.toLowerCase()) ||
        p.cause.toLowerCase().includes(filters.keyword.toLowerCase())
      : true;

    return matchReport && matchCompany && matchKeyword;
  });

  // Input değişimi
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setFilters({ reportType: "", company: "", keyword: "" });
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Bilgi Kütüphanesi</h2>

      {/* Filtre Alanı */}
      <Card className="p-3 mb-4 shadow-sm border-0">
        <Form>
          <Row className="g-3">
            <Col md={3}>
              <Form.Select
                name="reportType"
                value={filters.reportType}
                onChange={handleFilterChange}
              >
                <option value="">Rapor Türü</option>
                <option value="sikayet">Şikayet Raporu</option>
                <option value="bilgi">Bilgi Raporu</option>
                <option value="kalite">Kalite Sorunu</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Select
                name="company"
                value={filters.company}
                onChange={handleFilterChange}
              >
                <option value="">Firma Seç</option>
                <option value="Müşteri A">Müşteri A</option>
                <option value="Müşteri B">Müşteri B</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Control
                type="text"
                name="keyword"
                value={filters.keyword}
                onChange={handleFilterChange}
                placeholder="Anahtar Kelime (örn. beyaz pas)"
              />
            </Col>
            <Col md={3} className="d-flex gap-2">
              <Button
                type="button"
                variant="secondary"
                className="flex-grow-1"
                onClick={handleReset}
              >
                Sıfırla
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      {/* Problem Tablosu */}
      <Card className="shadow-sm border-0">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th>Firma</th>
              <th>Başlık</th>
              <th>Kısa Başlık</th>
              <th>Sebep</th>
              <th>İade</th>
              <th>Kayıp (Kg)</th>
              <th>Detay</th>
            </tr>
          </thead>
          <tbody>
            {filteredProblems.length > 0 ? (
              filteredProblems.map((p) => (
                <tr key={p.id}>
                  <td>{p.company}</td>
                  <td>{p.title}</td>
                  <td>{p.shortTitle}</td>
                  <td>{p.cause}</td>
                  <td>{p.returnStatus}</td>
                  <td>{p.lossKg}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => navigate(`/knowledge/${p.id}`)}
                    >
                      Görüntüle
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  Kayıt bulunamadı
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>
    </Layout>
  );
}

export default KnowledgeBase;
